import { DocumentServicesObject } from '@wix/document-services-types';

import { createPluginHostApi } from './pluginHostAPI';
import { PluginService } from './pluginService';
import { SlotsService } from './slotsService';

import { IExperimentsApiAdapter } from '../../utils/experimentsApiAdapter';

export function initPluginsServices(
  documentServicesAPI: DocumentServicesObject,
  experimentsAPI: IExperimentsApiAdapter,
) {
  const hostAPI = createPluginHostApi(documentServicesAPI, experimentsAPI);

  return {
    plugins: new PluginService(hostAPI),
    slots: new SlotsService(hostAPI),
  };
}
